import React from "react";

class EmojiIcon extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    return (
        <span>
          <img className='emojiicon' id={this.props.id} alt="EmojiIcon" src={this.props.icon} />
          {this.props.children}
        </span>
    );
  }
}

export default EmojiIcon;


// WEBPACK FOOTER //
// ./src/components/EmojiIcon/index.js